/** @jsx jsx */
import { jsx } from 'theme-ui';
import TextField from './TextField';

/**
 * A Textarea field controlled by formik.
 * @param {*} props The props forwarded to bootstrap's Form.Control.
 */
export default function TextArea(props) {
  return <TextField as="textarea" {...props} />;
}
